export default "__VITE_ASSET__jd1u_CrS__"